export default __webpack_public_path__ + "static/media/vinho2.a52c48d1.jpg";